import { useEffect } from "react";
import { useDispatch, useSelector } from "../../hooks";
import { advConv, setAppParams } from "../../redux/app.slice";
import { getPlatform } from "../../platform/platform";
import { resolveStartParam } from "../../platform/resolve-start-param";

const getParamsObject = (): { [key: string]: string } => {
    const stringParams = resolveStartParam(getPlatform());
    if (!stringParams)
        return {};

    const params = stringParams?.split('-');
    const regex = /([a-zA-Z]+)(\d+)/;

    const paramsObject = params.reduce<{ [key: string]: string }>((acc, item) => {
        const record = item.match(regex);
        if (record && record.length > 2) {
            const key = record[1];
            acc[key] = record[2];
        }
        return acc;
    }, {});

    return paramsObject;
}

export const PlatformParams = () => {
    const dispatch = useDispatch();
    const appData = useSelector(store => store.appData);

    useEffect(() => {
        if (appData.inited)
            return;

        const queryParams = getParamsObject();
        const { yclid, ref, adv } = queryParams;

        dispatch(setAppParams({ yclid: yclid ?? '', ref: ref ?? '', adv: advConv(adv ?? '') }));

    }, [dispatch, appData.inited]);

    return <></>;
}

